import { setPendingChunkErrorHandler } from 'utils/reloadOnChunkLoadError';

declare const __SPLASH_GAME_CHUNK__: string | undefined;

type GameModule = typeof import('./game');
let status: 'idle' | 'loading' | 'ready' | 'failed' = 'idle';
export const getGameStatus = () => status;
let promise: Promise<GameModule> | undefined;
let failures = 0;

export function loadGame(): Promise<GameModule> {
  if (promise) return promise;
  status = 'loading';
  const onPreloadError = (event: Event) => {
    const payload = (event as Event & { payload?: { message?: string } })
      .payload;
    const message = payload?.message ?? '';
    const file =
      typeof __SPLASH_GAME_CHUNK__ === 'undefined'
        ? undefined
        : __SPLASH_GAME_CHUNK__;
    const namesFile =
      /(?:https?:\/\/|\/)[^\s'")]+|[\w.-]+\.m?js(?:[?#][^\s'")]*)?/i.test(
        message,
      );
    if ((file && message.includes(file)) || !namesFile) event.preventDefault();
  };
  window.addEventListener('vite:preloadError', onPreloadError, true);
  setPendingChunkErrorHandler(onPreloadError);
  promise = (async () => {
    try {
      const file =
        typeof __SPLASH_GAME_CHUNK__ === 'undefined'
          ? undefined
          : __SPLASH_GAME_CHUNK__;
      const script = document.querySelector<HTMLScriptElement>(
        'script[type="module"][src]',
      );
      const retryUrl =
        failures && file && script ? new URL(file, script.src) : null;
      if (retryUrl) retryUrl.searchParams.set('retry', String(failures));
      const module: GameModule = retryUrl
        ? await import(/* @vite-ignore */ retryUrl.href)
        : await import('./game');
      if (!module?.default) throw new Error('Missing game module');
      status = 'ready';
      return module;
    } catch (error) {
      failures += 1;
      status = 'failed';
      promise = undefined;
      throw error;
    } finally {
      setPendingChunkErrorHandler();
      window.removeEventListener('vite:preloadError', onPreloadError, true);
    }
  })();
  return promise;
}
